// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PoCancelRequestQueue } from './po-cancel-request-queue';
import { PoDetail } from './po-detail';
import { PoTrx } from './po-trx';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PoDetailCancel extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key FK poDetail */
  poDetailId!: number;
  /** DateTimeOffset key */
  crtnTs!: Date;
  /** Int32 FK poTrx */
  poTrxId?: number;
  /** Int32 */
  qty!: number;
  /** Inv FK poDetailId,poDetailCancelCrtnTs */
  poCancelRequestQueue!: PoCancelRequestQueue;
  /** FK poDetailId */
  poDetail!: PoDetail;
  /** FK poTrxId */
  poTrx!: PoTrx;
}

